import { TaxSchema, ZodCreateTaxSchema, ZodUpdateTaxSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type Tax = TaxSchema;

export const getTax = async (taxId: string): Promise<Tax> => {
  const response = await apiClient.get<{ tax: Tax }>(`/api/tax/${taxId}`);
  return response.data.tax;
};

export const getTaxes = async (): Promise<Tax[]> => {
  const response = await apiClient.get<{ taxes: Tax[] }>("/api/tax");
  return response.data.taxes;
};

export const createTax = async (taxData: ZodCreateTaxSchema): Promise<Tax> => {
  const response = await apiClient.post<{ tax: Tax }>("/api/tax", taxData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.tax;
};

export const updateTax = async (taxData: ZodUpdateTaxSchema): Promise<Tax> => {
  const response = await apiClient.put<{ tax: Tax }>(`/api/tax/${taxData.id}`, taxData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.tax;
};

export const deleteTax = async (taxId: string): Promise<{ message: string; tax: Tax }> => {
  const response = await apiClient.delete<{ message: string; tax: Tax }>(`/api/tax/${taxId}`);
  return response.data;
};

export default getTax;
